/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid400,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid401,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid404,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid500,
} from "../../types/pecegePayBilletController/PostApiV1PecegepayBilletCoursefinpersonpaymentid.ts";

function getPostApiV1PecegepayBilletCoursefinpersonpaymentidUrl(
  courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/pecegepay/billet/${courseFinPersonPaymentId}` as const,
  };
  return res;
}

/**
 * @description Registra um novo boleto no Pecege Pay para a parcela informada.
 * @summary Registrar boleto
 * {@link /api/v1/pecegepay/billet/:courseFinPersonPaymentId}
 */
export async function postApiV1PecegepayBilletCoursefinpersonpaymentid(
  courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"],
  params?: PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid400
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid401
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid404
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1PecegepayBilletCoursefinpersonpaymentidUrl(
      courseFinPersonPaymentId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
